import clsx from 'clsx';
import StarRating, { BarRating } from '@pixum/rating';
import type { ResumeProps } from './types';
import Collapse from '@pixum/collapse';
import Label from '@pixum/label';
import Text, { TEXT_VARIANT } from '@pixum/text';
import './styles.css';

export function Resume({
  totalAmount,
  stats,
  average,
  ratingDescription,
  ratingStars,
  onSelectRating,
  selectedRating,
  customerRatingAuthenticityLabel,
  authenticityReviewsLink,
}: ResumeProps) {
  const barRatings = stats.map((ratingCount: number, index: number) => {
    const ratingValue = 5 - index;

    return (
      <BarRating
        className={clsx('resume__bar-rating', {
          'rating__bar--selected': selectedRating === ratingValue,
        })}
        ratingIndex={index}
        key={index}
        ratingCount={ratingCount}
        description={ratingStars}
        totalRatings={totalAmount}
        selectedRating={selectedRating}
        onSelect={() => onSelectRating(ratingValue)}
      />
    );
  });

  const starRatingSection = (
    <div className="resume__star-rating">
      <StarRating value={average} />
      <Text className="resume__star-rating__text" variant={TEXT_VARIANT.CAPTION}>
        {ratingDescription}
      </Text>
    </div>
  );

  const ratingsContent = (
    <>
      {barRatings}
      <Label
        className="resume__authenticity-label"
        text={customerRatingAuthenticityLabel}
        title={customerRatingAuthenticityLabel}
        href={authenticityReviewsLink?.url}
      />
    </>
  );

  return (
    <div className="resume">
      <div className="resume__desktop">
        {starRatingSection}
        {ratingsContent}
      </div>
      <div className="resume__mobile">
        <Collapse id="resume__collapse" headline={starRatingSection} expanded={false}>
          {ratingsContent}
        </Collapse>
      </div>
    </div>
  );
}
